import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  forgetRequestedUrl,
  consumeRequestedUrl,
  getRequestedUrl,
  hasRequestedUrl,
  saveRequestedUrl,
} from './useRequestedUrl.helpers.ts';
import type { TRequestedUrlMemory } from './useRequestedUrl.types.ts';

const noTransientParams: readonly string[] = [];

export const useRequestedUrl = (
  transientParams: readonly string[] = noTransientParams,
): TRequestedUrlMemory => {
  const navigate = useNavigate();

  return useMemo(
    () => ({
      hasRequestedUrl,
      rememberRequestedUrl: () => {
        const requestedUrl = getRequestedUrl(
          window.location.href,
          transientParams,
        );

        saveRequestedUrl(requestedUrl);
      },
      forgetRequestedUrl,
      goToRequestedUrl: () => {
        const requestedUrl = consumeRequestedUrl();

        if (!requestedUrl) {
          return;
        }

        navigate(requestedUrl, { replace: true });
      },
    }),
    [transientParams, navigate],
  );
};
